import logo from './logo.svg';
import './App.css';
import { Route, Routes } from 'react-router-dom';
import Dashboard from './Dashboard/Dashboard';
import Login from './Login';
import { UserProvider } from './Context/UserContext';

function App() {
  return (
    <div className="App">
      <UserProvider>
     <Routes>
      <Route path="/" element={<Login />} />

 <Route path="/dashboard" element={<Dashboard />}></Route>

     
     </Routes>
     </UserProvider>
    </div>
  );
}

export default App;
